/**
 * <cart-reservation-timer> — MM:SS countdown, end time kept in sessionStorage so it
 * survives the drawer re-rendering on every cart change.
 */
if (!customElements.get('cart-reservation-timer')) {
  customElements.define(
    'cart-reservation-timer',
    class CartReservationTimer extends HTMLElement {
      connectedCallback() {
        this.timerEl = this.querySelector('.js-cart-res-timer');
        this.durationMs = parseInt(this.dataset.durationMs, 10) || 300000;
        this.storageKey = this.dataset.storageKey || 'cart-reservation-end';
        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      readEnd() {
        try {
          return parseInt(sessionStorage.getItem(this.storageKey), 10);
        } catch (e) {
          return NaN;
        }
      }

      writeEnd(end) {
        try {
          sessionStorage.setItem(this.storageKey, String(end));
        } catch (e) {
          /* storage unavailable — timer still runs for this render */
        }
      }

      tick() {
        const now = Date.now();
        let end = this.readEnd();
        if (!end || isNaN(end) || end <= now) {
          end = now + this.durationMs;
          this.writeEnd(end);
        }
        const totalSec = Math.floor(Math.max(0, end - now) / 1000);
        const m = String(Math.floor(totalSec / 60)).padStart(2, '0');
        const s = String(totalSec % 60).padStart(2, '0');
        if (this.timerEl) this.timerEl.textContent = `${m}:${s}`;
      }
    }
  );
}
